export interface PageHero {
    imageHorizontal: string
    imageVertical: string
    imageAlt: string
    heroMode: string
}

export const usePageHero = () => {
    const config = useRuntimeConfig()
    const apiBase = config.public.apiBase

    const getHero = async (pageKey: string): Promise<PageHero | undefined> => {
        try {
            return await $fetch<PageHero>(`${apiBase}/oxoweb/pageheroes/${pageKey}`)
        } catch {
            return undefined
        }
    }

    return {
        getHero
    }
}
